export default {
  "hero": {
    "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yorkshire Terrier"])}
  },
  "lost": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["If I'm lost, please help"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I may be scared. Please be gentle with me and reach out to my family using the form below — they will contact you as soon as possible."])},
    "form": {
      "subject": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manolito was found!"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your name"])},
      "name_ph": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jane Doe"])},
      "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your phone number or email"])},
      "contact_ph": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["+1 234 567 890"])},
      "location": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Where did you find me?"])},
      "location_ph": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Park, street, neighborhood..."])},
      "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Any additional details"])},
      "message_ph": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is he okay? Any other info that might help..."])},
      "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send message to my family 🐾"])}
    }
  },
  "petting": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Where I love to be petted"])},
    "spots": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Behind my ears"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My back"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Under my chin"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My belly"])}
    ]
  },
  "loves": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Things I love"])},
    "items": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parks with grass"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiking in the mountains"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Going for walks"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Little sticks from the park"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greeting other dogs"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["White dogs especially"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chasing balls"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Playing chase"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tug of war"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destroying cardboard boxes"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unrolling toilet paper"])}
    ]
  },
  "fears": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["What scares me"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please keep me away from these — I may try to run or hide."])},
    "items": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Some bicycles"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suspiciously stacked branches"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["People wearing helmets or large uniforms"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wild animal sounds"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piles of trash bags"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The ocean"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heights"])}
    ]
  },
  "chases": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["What I might run after"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please hold my leash tight! I can bolt without warning."])},
    "items": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Other dogs"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["White dogs"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Other dogs' balls"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pigeons"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Small birds"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fish — I'll jump into the water!"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["People who look like someone I know"])}
    ]
  },
  "diet": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My diet"])},
    "cant_eat_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I cannot eat"])},
    "forbidden": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🧅 Onion"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🍫 Chocolate"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🥜 Nuts"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🪵 Park sticks or wood"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🍋 Acidic fruits"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🍬 Sugar"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🧂 Salt"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🍽️ Human food in general"])}
    ],
    "schedule_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I eat 3 times a day"])},
    "schedule_desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I eat a sausage-style wet food kept in the freezer. Here's how to prepare it:"])},
    "steps": [
      {
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🌙 The night before"])},
        "instruction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Take the food sausage out of the freezer and leave it at room temperature overnight."])}
      },
      {
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["☀️ 8:00 AM"])},
        "instruction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The sausage should be soft. Open it, heat 1/3 of the content in the microwave on a ceramic plate. Wait 2 minutes to cool before serving."])}
      },
      {
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🌤️ 12:00 PM"])},
        "instruction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heat another 1/3 of the sausage in the microwave. Wait 2 minutes to cool before serving."])}
      },
      {
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🌆 Evening"])},
        "instruction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heat the last 1/3 of the sausage in the microwave. Wait 2 minutes to cool before serving."])}
      }
    ]
  },
  "commands": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tricks I know"])},
    "items": [
      {
        "word": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sit"])},
        "how": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Say \"sit\" and I'll sit right down."])}
      },
      {
        "word": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spin"])},
        "how": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Make a fist, extend your index finger, and draw a circle to the right — I'll spin!"])}
      },
      {
        "word": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shake"])},
        "how": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reach your hand toward my paw and say \"jalo\" — I'll shake it!"])}
      }
    ]
  },
  "vet": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["If I seem sick"])},
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loyal Animals Veterinary Clinic"])},
    "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact my vet on WhatsApp"])}
  },
  "footer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Made with 🐾 and love"])},
  "nav": {
    "cuidados": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Care guide"])}
  },
  "home": {
    "tagline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yorkshire Terrier"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I'm a very adventurous little dog.\nIf you found me, please reach out to my family 🐾"])},
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["How to care for me →"])}
  },
  "cuidados": {
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Everything you need to know to take care of me."])}
  }
}